export const sortTrainingUsersByName = (users = []) => {
    return [...users].sort((a, b) => {
        return (a.name ?? "").localeCompare(b.name ?? "", "pt-BR", {
            sensitivity: "base",
        });
    });
};
